module.exports = __webpack_public_path__ + "img/PPMPRA5.63f443a6.png";